import splitUrl from './splitUrl';

/**
 * Remove the `from_url` query parameter from a url.
 *
 * Useful if you're adding `from_url` so it doesn't keep appending.
 */
const removeFromUrl = (href: string | null) => {
  if (!href || href.indexOf('?') < 0) {
    return href;
  }
  const { baseHref, queryString } = splitUrl(href);
  const queryStringParts = queryString.split('&');
  const cleanQueryStringParts = queryStringParts.filter(
    part => !part.startsWith('from_url=')
  );
  const cleanQueryString = cleanQueryStringParts.join('&');
  if (cleanQueryString === '') {
    return baseHref;
  }
  return `${baseHref}?${cleanQueryString}`;
};

export default removeFromUrl;
